import { PlatePair, PlateType } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

type PlateGauge = 16 | 18 | 20;

/** Corresponds to server-side method `GetPlateGauge` in PlateType.cs */
const plateGauges: Record<PlateType, PlateGauge> = {
  M20: 20,
  M20HS: 20,
  MT20HS: 20,
  Eagle20: 20,
  Eagle20HS: 20,
  TL20: 20,
  MT20: 20,
  AS20: 20,
  AlpineW: 20,
  AlpineT: 20,
  Alpine20H: 20,
  CH20: 20,
  CH20S: 20,
  CherokeeB: 20,
  MII20: 20,
  MII20HS: 20,
  AS20HS: 20,
  Any20: 20,
  Any20HS: 20,
  Combo20: 20,
  Combo20HS: 20,
  M18SHS: 18,
  MT18HS: 18,
  Eagle18: 18,
  Eagle18HS: 18,
  TL18: 18,
  MT18: 18,
  AS18HS: 18,
  AS18S6: 18,
  AS18S5: 18,
  Alpine18SS: 18,
  CH18: 18,
  CH18HS: 18,
  M18AHS: 18,
  MTH18: 18,
  SMH18: 18,
  Any18: 18,
  Any18HS: 18,
  Combo18: 18,
  Combo18HS: 18,
  Combo16: 16,
  M16: 16,
  Eagle16: 16,
  TL16: 16,
  MT16: 16,
  MII16: 16,
};

const poundsPerSquareInchForGauge: Record<PlateGauge, number> = { 20: 0.011502, 18: 0.01497, 16: 0.0184 };

const tPlateTopWidthInInches = 3;
const tPlateBottomIndentInInches = 2;

function getPlateAreaInSquareInches({
  geometryType,
  width,
  length,
}: Pick<PlatePair, 'geometryType' | 'width' | 'length'>) {
  switch (geometryType) {
    case 'Rectangular':
    case 'Hinged':
      return length * width;
    case 'TPlate':
      return (
        length * tPlateTopWidthInInches + (length - 2 * tPlateBottomIndentInInches) * (width - tPlateTopWidthInInches)
      );
    case 'BevelPlateLeftHanded':
    case 'BevelPlateRightHanded':
      return length * width - (width * width) / 2;
    default:
      return assertExhaustiveSwitch(geometryType);
  }
}

/** Corresponds to server-side method `Weight(this IPlatePair)` in WeightUtilities.cs */
export function getPlatePairWeightInPounds(
  platePair: Pick<PlatePair, 'plateType' | 'geometryType' | 'width' | 'length'>,
) {
  return getPlateAreaInSquareInches(platePair) * poundsPerSquareInchForGauge[plateGauges[platePair.plateType]] * 2;
}
